import { render, staticRenderFns } from "./Row.vue?vue&type=template&id=2f142936&scoped=true&"
import script from "./Row.vue?vue&type=script&lang=ts&"
export * from "./Row.vue?vue&type=script&lang=ts&"
import style0 from "./Row.vue?vue&type=style&index=0&id=2f142936&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f142936",
  null
  
)

export default component.exports